import { css } from '@emotion/react';

export const placeholderCx = css`
  color: #6d6d6e;
  opacity: 0.6;
`;
